import styled from "styled-components"
import { Annotation } from "../../../components/common/general-styles.component"

export const CopyrightsWrapper = styled(Annotation)`
  grid-area: Copyrights;
  color: ${({ theme }) => theme.color.textFooter};
  margin-top: 30px;
  margin-bottom: 40px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    margin-top: 40px;
  }
`
